/**
 * @desc 绑定
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.StagingAreaDetailAddRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/stagingAreaMaster/binding`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
